import { useEffect, useState } from 'react'
import { Row, Col, Button, Container } from 'react-bootstrap'
import { AiFillChrome } from 'react-icons/ai'
import { BsFillCalendar3EventFill } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import API from "../../api/api";
import Actions from '../../redux/actions';

export default function AddExtension(props) {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const usageType = useSelector(state => state.usageType)
    useEffect(() => {
    }, [])


    const _getStarted = async () => {
        const res = await API.getUser()
        const accounts = await API.getSubAccounts()
        const stats = await API.getStats()
        const filenames = await API.getFileNames()
        dispatch(Actions.setFileNames(filenames))
        dispatch(Actions.setStats(stats.stats))
        dispatch(Actions.setUser(res.user))
        dispatch(Actions.setAccounts(accounts))

        navigate('/', { replace: true })
    }

    return (
        <Container className='p-4 text-center'>
            <Row>
                <Col md={8} className={`bg-white shadow rounded my-auto mx-auto animate__animated animate__fadeIn text-center `}>
                    <div className='p-3'>
                        <h1>Add Chrome Extension</h1>
                        <Row className='justify-content-center'>
                            <Col md={8}>
                                <a className='btn btn-primary mt-3' target='__blank' href='https://chrome.google.com/webstore/detail/scamwall/pjkegbkgamcijobfjmpbljhbolejfnip'><AiFillChrome /> Add Chrome Extension</a>

                                <p className='mt-2'>If you are using ScamWall yourself or would like to try it out, install the ScamWall Chrome Extension by clicking the button above.</p>
                                <p>Sign in to the extension, and come back to this screen when you're done. Then click the "Next" button</p>
                                <p><small><em>(Note: ScamWall Currently Only Works on Chrome and Chrome based browsers. If that link did not work, please copy the link to Chrome.)</em></small></p>

                                <Button variant='primary' onClick={() => dispatch(Actions.setSignupStep(8))}>Next</Button>
                                <br />

                                <Button variant='link mt-3' onClick={() => dispatch(Actions.setSignupStep(8))}>Skip Installation</Button>

                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}